<template>
  <div class="unHasViolation">
    <div class="con">
      <!-- <van-icon :name="iconfontName" class="icon" /> -->
      <span :class="iconfontName" class="iconfont"></span>
      <div class="tip">
        <span v-html="tipText"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "vant";
export default {
  name: "SouhuoH5Unhasviolation",
  props: {
    tipText: {
      type: String,
      default: () => {
        return "暂无更多内容~";
      },
    },
    iconfontName: {
      type: String,
      default: () => {
        return "icon-guzhang";
      },
    },
  },
  components: {
    "van-icon": Icon
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.unHasViolation {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 300px;
    // background-color: #fff;
    .con {
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .iconfont {
        font-size: 50px;
        color: #9e9d9b;
        margin-bottom: 20px;
      }
      .tip {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        font-size: 14px;
        color: #9ca1ac;
        line-height: 20px;
        text-align: center;
      }
    }
  }
</style>